/*
PURPOSE: Editorial body copy block — warm ink, measured line length and the
settled body type token from the /design-sandbox/editorial iterations.
USE CASES:
- Section body paragraphs across Home2 (accepts one or many <p> children).
DOMAIN BOUNDARIES:
- Presentation only. Copy passed as children (no copy here).
- No imports from design-sandbox/.
*/

import React from 'react';

interface BodyProseProps {
  children: React.ReactNode;
  className?: string;
}

const BodyProse: React.FC<BodyProseProps> = ({ children, className }) => {
  return (
    <div
      className={`text-editorial-body text-editorial-muted/80 max-w-prose space-y-5 ${className ?? ''}`}
    >
      {children}
    </div>
  );
};

export default BodyProse;
